import { useMemo } from "react";
import { normalizeCurrencyPrice } from "../utils/price";

/**
 * Hook to calculate service totals by type
 * Filters out removed services (status === 0)
 */
export const useServiceTotals = (selectedServices) => {

  const calculateServiceTypeTotal = (type) => {
    return selectedServices
      .filter(
        (service) =>
          service.type === type  && service.status !== 3,
      )
      .reduce(
        (total, service) =>
          total + (normalizeCurrencyPrice(service.price) || 0),
        0,
      )
      .toFixed(2);
  };

  const totalAmount = useMemo(() => {
    return selectedServices
      .filter((s) => s.status !== 0 && s.status !== 3)
      .reduce(
        (sum, service) => sum + (normalizeCurrencyPrice(service.price) || 0),
        0,
      )
      .toFixed(2);
  }, [selectedServices]);

  const activeServicesCount = useMemo(() => {
    return selectedServices.filter((s) => s.status !== 0 && s.status !== 3)
      .length;
  }, [selectedServices]);

  return {
    calculateServiceTypeTotal,
    totalAmount,
    activeServicesCount,
  };
};

export default useServiceTotals;
